import OfficeHoursDrawer from './office-hours-drawer';

export default OfficeHoursDrawer;
